var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"safe-credit-score text-center fw-bold small",domProps:{"innerHTML":_vm._s(_vm.$t('pages.marketing.landing.safeCreditScore'))}})}
var staticRenderFns = []

export { render, staticRenderFns }